import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
const DisplayDensityOption: LazyOption = createLazyOption(
    {
        key: 'Density',
        titleStringKey: 'optionTitle_messageHeight',
        searchTermsStringKey: 'optionTitle_messageHeight',
        isHidden: () => !isFeatureEnabled('tri-density-controls'),
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default DisplayDensityOption;
